import styled from '@emotion/styled';
import {css} from '@emotion/react';

import {ReactComponent as EmailSVG} from '../../assets/icons/ic_email.svg';
import {ReactComponent as PhoneSVG} from '../../assets/icons/ic_phone.svg';
import {ellipsisStyle} from '../../shared/styles';

export const ContactPageWrapper = styled.div`
  display: flex;

  // Desktop
  @media screen and (min-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    justify-content: center;
    align-items: center;
    gap: ${({theme}) => theme.gap.desktop.xl};

    // Put max-width for children
    & > * {
      max-width: 50%;
    }
  }

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    flex-direction: column;
    gap: ${({theme}) => theme.gap.desktop.lg};
  }
`;

export const CardContactWrapper = styled.div<{isHoverable: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.xs};
  padding: ${({theme}) => theme.padding.desktop.md};

  a {
    ${ellipsisStyle}
  }

  ${({theme, isHoverable}) =>
    isHoverable &&
    css`
      &:hover a {
        color: ${theme.color.primary_70};
        text-decoration: underline;
      }
    `}
`;

// ICONS
const styledIcon = (
  IconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
) => styled(IconComponent)`
  width: ${({theme}) => theme.icon.size.lg};
  height: ${({theme}) => theme.icon.size.lg};
  fill: ${({theme}) => theme.color.primary_70};
`;
export const IconEmail = styledIcon(EmailSVG);
export const IconPhone = styledIcon(PhoneSVG);
